module.exports = __webpack_public_path__ + "img/cards.a3cb8f16.webp";